import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import isEqual from 'lodash/isEqual';
import { ModalDialog, ModalDialogMessages as sharedMsgs, generateValidation } from 'ecs-react-components/dist/index.es';

import QueryString from 'query-string';
import { messages } from '../../../containers/SignUp/VerifyIdentity/VerifyIdentityForm.i18n';
import VerifyIdentityForm from '../../../containers/SignUp/VerifyIdentity/VerifyIdentityForm';
import { loadVerificationFields } from '../../../redux/modules/signup/verify-identity/verify-identity-middleware';
import { loadPatientIdentifierLabel } from '../../../redux/modules/localization/localization-middleware';
import { DedicatedWorkflowPanel } from '../../../components/SystemShared/DedicatedWorkflowPanel';
import { languageChange } from '../../../redux/modules/language/language-middleware';

const validations = {
  firstName: {
    required: true,
    validtateOnBlue: false,
  },
  lastName: {
    required: true,
    validateOnBlur: false,
  },
  day: {
    required: true,
    pattern: /^[0-9]+$/,
    validateOnBlur: false,
  },
  month: {
    required: true,
    pattern: /^[0-9]+$/,
    validateOnBlur: false,
  },
  year: {
    required: true,
    pattern: /^[0-9]+$/,
    validateOnBlur: false,
  },
  pin: {
    required: false,
    validateOnBlur: false,
  },
  mrn: {
    required: false,
    validateOnBlur: false,
  },
  ssn: {
    required: false,
    validateOnBlur: false,
  },
};

class VerifyIdentityPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      nextRoute: '',
      formValidate: {},
    };
  }

  componentDidMount() {
    const queries = QueryString.parse(location.search);
    if (queries.language && queries.pin) {
      this.props.dispatch(languageChange(queries.language));
      this.props.history.push(`/sign-up?pin=${queries.pin}`);
    }

    this.props.dispatch(loadVerificationFields());
    this.props.dispatch(loadPatientIdentifierLabel(this.props.languageCode));

    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block(this.leaveHookFunction.bind(this));
    }
  }

  UNSAFE_componentWillReceiveProps(oldProps, newProps) {
    if (!oldProps.verificationFields) {
      return;
    }

    let verificationFields = oldProps.verificationFields;

    if (newProps.verificationFields &&
      !isEqual(oldProps.verificationFields.sort(), newProps.verificationFields.sort())) {
      verificationFields = newProps.verificationFields;
    }

    if (verificationFields) {
      verificationFields.forEach((field) => {
        if (field) {
          validations[field.toLowerCase()].required = true;
        }
      });

      this.setState({
        formValidate: generateValidation(validations),
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
  }

  leaveHookFunction = (next) => {
    let showCancelModal = true;
    if (next.pathname === '/create-account') {
      showCancelModal = false;
      this.allowRouteToChange = true;
    }

    if (!this.state.isShowCancelModal) {
      this.setState({
        isShowCancelModal: showCancelModal,
        nextRoute: next.pathname,
      });
    }

    return this.allowRouteToChange;
  };

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;
    this.props.history.push('/sign-up');
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
    this.props.history.push(this.state.nextRoute);
  }

  render() {
    const { verificationFields, patientIdentifierLabel, languageCode } = this.props;
    const { formValidate, isShowCancelModal } = this.state;
    if (verificationFields && patientIdentifierLabel
      && Object.keys(formValidate).length > 0) {
      return (
        <DedicatedWorkflowPanel headerTitle={ messages.page.title } instruction={ messages.page.instruction }>
          <VerifyIdentityForm verificationFields={verificationFields}
            patientIdentifierLabel={patientIdentifierLabel}
            languageCode={languageCode}
            history={this.props.history}
            {...formValidate}
          />
          <ModalDialog show={isShowCancelModal}
            title={sharedMsgs.cancelModal.title}
            message={sharedMsgs.cancelModal.message }
            submitBtnText={ sharedMsgs.cancelModal.submitBtnText }
            submitBtnTextDescription={ sharedMsgs.cancelModal.submitBtnTextDescription}
            hideBtnText={sharedMsgs.cancelModal.hideBtnText.button}
            hideBtnTextDescription={sharedMsgs.cancelModal.hideBtnText.description}
            onSubmit={this.submitCancelModal}
            onHide={this.hideCancelModal}
            id={1}
          />
        </DedicatedWorkflowPanel>
      );
    }

    return <div></div>;
  }
}

VerifyIdentityPage.propTypes = {
  history: PropTypes.object,
  dispatch: PropTypes.func,
  verificationFields: PropTypes.array,
  patientIdentifierLabel: PropTypes.string,
  languageCode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  verificationFields: state.signUp.verificationFields,
  patientIdentifierLabel: state.localization.patientIdentifierLabel,
  languageCode: state.language.languageCode,
});

export default withRouter(connect(mapStateToProps)(VerifyIdentityPage));
